import { render, staticRenderFns } from "./handlingUnqualified.vue?vue&type=template&id=07c2568e&scoped=true"
import script from "./handlingUnqualified.vue?vue&type=script&lang=js"
export * from "./handlingUnqualified.vue?vue&type=script&lang=js"
import style0 from "./handlingUnqualified.vue?vue&type=style&index=0&id=07c2568e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2568e",
  null
  
)

export default component.exports